export function toFixedNumber(
  amount: string | undefined,
  decimalPlaces?: number
) {
  const normalizedAmount = Number(amount);
  if (!Number.isFinite(normalizedAmount)) {
    return;
  }

  if (decimalPlaces === undefined) {
    return normalizedAmount;
  }

  return Number(normalizedAmount.toFixed(decimalPlaces));
}
